import {Component, ElementRef, EventEmitter, HostListener, Input, OnInit, Output, ViewChild} from '@angular/core';
import {Observable} from "rxjs";
import {MediaImage, PictureTypeEnum} from "../../../../store/entities/media-image/media-image.model";
import {environment} from "../../../../../environments/environment";
import {selectMediaImages} from "../../../../store/entities/media-image/media-image.selectors";
import {StorageService} from "../../../../services/storage.service";
import {Store} from "@ngrx/store";
import {AppState} from "../../../../store/reducers";
import {Apollo} from "apollo-angular";
import {ProfileDto} from "../../../../store/entities/instution-settings/instution-user/instution-user.model";
import {AuthService} from "../../../../services/auth.service";
import {
  CitizensServicesSector
} from "../../../../store/entities/citizens/citizens-services-sector/citizens-services-sector.model";
import {
  GET_ALL_CITIZEN_SECTOR
} from "../../../../store/entities/citizens/citizens-services-sector/citizens-services-sector.graphql";
import {
  CitizensServicesCategory
} from "../../../../store/entities/citizens/citizens-services-category/citizens-services-category.model";
import {
  GET_CITIZEN_SERVICES_CATEGORY
} from "../../../../store/entities/citizens/citizens-services-category/citizens-services-category.graphql";
import {StoreItemActions} from "../../../../store/entities/store-item/store-item.actions";
import {StoreItemEntity} from "../../../../store/entities/store-item/store-item.model";
import {
  GET_FREQUENTLY_ASKED_QUESTION_QUERY
} from "../../../../store/entities/frequently-asked-question/frequently-asked-question.graphql";

@Component({
  selector: 'app-citizen-header',
  templateUrl: './citizen-header.component.html',
  styleUrls: ['./citizen-header.component.scss']
})
export class CitizenHeaderComponent implements OnInit {
  @ViewChild('mobileMenu') mobileMenu: ElementRef;
  @Input() hasHomeButton = true
  @Input() fromHomePortal = false
  banners$: Observable<MediaImage[]>
  fileUrl = environment.FILE_SERVER_URL;
  @Output() scrollToContainer = new EventEmitter<string>();
  @Output() msaadaAiClicked = new EventEmitter();
  activeLanguage: 'en' | 'sw'
  userProfile: ProfileDto
  photo: any;

  showStickyNav: boolean = false
  hoveredMenu: string;
  protected readonly location = location;

  constructor(
    private storageService: StorageService,
    private store: Store<AppState>,
    private authService: AuthService
  ) {
  }

  toggleNav(): void {
    this.handleHover(null);
    const element = this.mobileMenu?.nativeElement;
    if (element.classList.contains('mobile-toggle')) {
      element.classList.remove('mobile-toggle');
    } else {
      element.classList.add('mobile-toggle');
    }
  }

  handleHover(menu) {
    this.hoveredMenu = menu;
  }

  activeMenu(menu) {
    return this.hoveredMenu == menu;
  }

  getFaq() {
    this.store.dispatch(StoreItemActions.getStoreItemsMergeMap({
      entity: StoreItemEntity.faqs,
      query: GET_FREQUENTLY_ASKED_QUESTION_QUERY,
      filtering: {}
    }))
  }


  ngOnInit(): void {
    this.userProfile = this.storageService.getItem('profile')
    this.activeLanguage = this.storageService.getItem('language') || 'en'
    this.banners$ = this.store.select(selectMediaImages(PictureTypeEnum.BANNER))

    this.photo = environment.FILE_SERVER_URL + this.userProfile.profilePhoto
    this.getFaq();
  }

  onChangeLanguage(lang: 'en' | 'sw') {
    this.storageService.setItem('language', lang)
    window.location.reload()
  }

  @HostListener('window:scroll', ['$event'])
  onScroll(event: Event) {
    this.showStickyNav = window.pageYOffset >= 150
  }

  logout() {
    this.authService.logout();
  }

}
